module.exports = __webpack_public_path__ + "static/media/taxi_salmon.89589579.svg";